/**
 * Gen1 Single relay with power monitoring template
 * Used by: SHSW-PM (Shelly 1PM)
 *
 * Gen1 devices use HTTP endpoints instead of RPC
 */

import {
	createGen1TurnAction,
	createGen1StateCondition,
	createGen1StateChangedTrigger,
} from './stateManagement.js';
import { createGen1PowerLevelCondition, createGen1PowerThresholdTrigger } from './powerMonitoring.js';

export function createGen1SingleRelayPMTemplate() {
	return {
		deviceType: 'gen1_single_relay_pm',
		generation: 1,
		channels: ['relay:0'],
		actions: {
			turn: createGen1TurnAction('relay', true),
		},
		conditions: {
			isOn: createGen1StateCondition('relay'),
			powerLevel: createGen1PowerLevelCondition(3680),
		},
		triggers: {
			stateChanged: createGen1StateChangedTrigger('relay'),
			powerThreshold: createGen1PowerThresholdTrigger(3680),
		},
	};
}
